import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import firebase from "../../firebase"; // Assure-toi d'importer ta config Firebase v8

const ViewEmail = () => {
  const { emailId } = useParams();
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const docRef = firebase.firestore().collection("emails").doc(emailId);
        const docSnap = await docRef.get();

        if (docSnap.exists) {
          setEmail(docSnap.data());
        } else {
          console.error("Aucun email trouvé !");
        }
      } catch (error) {
        console.error("Erreur lors de la récupération de l'email :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmail();
  }, [emailId]);

  if (loading) return <p>Chargement...</p>;
  if (!email) return <p>Email introuvable.</p>;

  return (
    <div>
      <h1>{email.subject}</h1>
      <div dangerouslySetInnerHTML={{ __html: email.html }} />
    </div>
  );
};

export default ViewEmail;